import { createContext, useContext, useEffect, useState } from 'react'

interface RegionalContextValues {
  countryCode: string
  // add other properties like currency, language, locale, dates etc. as needed
}

const RegionalContext = createContext<RegionalContextValues>({
  countryCode: '',
})

export const useRegionalContext = () => {
  return useContext(RegionalContext)
}

export const RegionalContextProvider = ({
  values,
  children,
}: {
  values: RegionalContextValues
  children: React.ReactNode
}) => {
  const [countryCode, setCountryCode] = useState<string>(() => {
    const countryOverride = typeof localStorage === 'undefined' ? '' : localStorage.getItem('l2_country_override') || ''
    return countryOverride || values.countryCode || ''
  })

  useEffect(() => {
    // this value are coming from pageProps, so it will be available in SSR
    // in case its not available, don't set it, so that client can use, last used countryCode
    if (!values.countryCode) {
      return
    }
    if (values.countryCode === countryCode) {
      return
    }
    const countryOverride = localStorage.getItem('l2_country_override') || ''
    // only set last valid countryCode
    setCountryCode(countryOverride || values.countryCode)
  }, [values.countryCode, countryCode])

  return <RegionalContext.Provider value={{ countryCode }}>{children}</RegionalContext.Provider>
}
